'use client'

import { cn } from '@/lib/utils'

import { CopyLinkIcon, EyeOutlineIcon } from '@public/icons'
import { Eye } from 'lucide-react'
import * as React from 'react'
import { toast } from 'sonner'
import { Label } from './label'

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & { label?: string, showCopyIcon?: boolean }
>(({ className, type, name, label, showCopyIcon = false, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState<boolean>(false)
  const handleCopy = () => {
    if (props.value) {
      navigator.clipboard
        .writeText(props.value.toString())
        .then(() => {
          toast('Copied to clipboard!')
        })
        .catch(() => {
          toast('Failed to copy to clipboard!')
        })
    }
  }

  return (
    <div className="relative w-full space-y-2">
      {label && <Label htmlFor={name}>{label}</Label>}
      <input
        name={name}
        type={showPassword ? 'text' : type}
        className={cn(
          'flex h-14 w-full rounded-md border border-[#E5E7EB] bg-[#F8F8F9] px-3 py-2 text-base font-medium file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:font-medium placeholder:text-[#6B7280] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />

      {type === 'password' ? (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className={`absolute top-[40%] z-10 ${showCopyIcon ? 'right-12 -translate-y-1/2' : 'right-4 -translate-y-1/2'} transform`}
        >
          {showPassword ? (
            <EyeOutlineIcon />
          ) : (
            <Eye size={20} className="text-[#044752]" strokeWidth={2} />
          )}
        </button>
      ) : null}
      {showCopyIcon && (
        <div
          onClick={handleCopy}
          className="absolute right-4 top-[40%] z-10 -translate-y-1/2 transform cursor-pointer"
        >
          <CopyLinkIcon />
        </div>
      )}
    </div>
  )
})
Input.displayName = 'Input'

export { Input }
